module.exports = __webpack_public_path__ + "static/bg-f3db4d36020454c99d3195e0166e670d.svg";